import initialState from './initialState';

export default (state = initialState.myIndex, action) => {
	//
	switch (action.type) {
		case 'RESET_WHOLE_STATE':
			return initialState.myIndex;
		//
		//
		case 'SET_MY_INDEX':
			return {
				...state,
				myIndex: action.myIndex,
			};

		default:
			return state;
	}
};
